import React from 'react';
import Loadable from 'react-loadable';

const LoadableWidget = Loadable({
  loader: () =>
    import(/* webpackChunkName: "PokerSundayMillionWidget" */ './PokerSundayMillionWidget'),
  modules: ['./PokerSundayMillionWidget'],
  loading: () => <div />
});

export default LoadableWidget;
